module.exports = __webpack_public_path__ + "img/4.154537b5.jpg";